// assets
import { IconUserCheck, IconBasket, IconMessages, IconLayoutKanban, IconMail, IconCalendar, IconNfc } from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc
};

// ==============================|| EFECTIVO Y EQUIVALENTES AL EFECTIVO MENU ITEMS ||============================== //

const efectivo = {
    id: 'efectivo',
    title: 'Efectivo y Equivalentes al Efectivo',
    type: 'group',
    children: [
        {
            id: 'cajas',
            title: 'Cajas',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'nueva_caja',
                    title: 'Nueva Caja',
                    type: 'item',
                    url: '/user/new-cajas/0'
                },
                {
                    id: 'lista_cajas',
                    title: 'Lista Cajas',
                    type: 'item',
                    url: '/user/list-cajas-view'
                },                
            ]
        },
        {
            id: 'bancos',
            title: 'Bancos',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'nuevo_banco',
                    title: 'Nuevo Banco',
                    type: 'item',
                    url: '/user/new-bancos/0'
                },
                {
                    id: 'lista_bancos',
                    title: 'Lista Bancos',
                    type: 'item',
                    url: '/user/list-bancos-view'
                },                
            ]
        },
        {
            id: 'tarjetas_credito',
            title: 'Tarjetas Crédito',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'nueva_tarjeta',
                    title: 'Nueva Tarjeta',
                    type: 'item',
                    url: '/user/new-tarjetas/0'
                },
                {
                    id: 'lista_bancos',
                    title: 'Lista Bancos',
                    type: 'item',
                    url: '/user/list-bancos-view'
                },                
            ]
        },
        {
            id: 'tipos_movimientos',
            title: 'Tipos de Movimientos',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'nuevo_tipo_movimiento_caja',
                    title: 'Nuevo Tipo Movimiento Caja',
                    type: 'item',
                    url: '/user/new-tipo-movimiento-caja/0'
                },
                {
                    id: 'lista_tipo_movimiento_caja',
                    title: 'Lista Tipo Movimiento Caja',
                    type: 'item',
                    url: '/user/list-tipo-movimiento-caja-view'
                },
                {
                    id: 'nuevo_tipo_movimiento_banco',
                    title: 'Nuevo Tipo Movimiento Banco',
                    type: 'item',
                    url: '/user/new-tipo-movimiento-bancos/0'
                },
                {
                    id: 'lista_tipo_movimiento_banco',
                    title: 'Lista Tipo Movimiento Banco',
                    type: 'item',
                    url: '/user/list-tipo-movimiento-bancos-view'
                },
            ]
        },
        {
            id: 'movimientos_caja',
            title: 'Movimientos de Caja',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'nuevo_movimiento_caja',
                    title: 'Nuevo Movimiento Caja',
                    type: 'item',
                    url: '/user/new-movimientos-caja/0'
                },
                {
                    id: 'lista_movimientos_caja',
                    title: 'Lista Movimientos Caja',
                    type: 'item',
                    url: '/user/list-movimientos-caja-view'
                },                
            ]
        },
        {
            id: 'movimientos_banco',
            title: 'Movimientos de Banco',
            type: 'collapse',
            icon: icons.IconUserCheck,
            children: [
                {
                    id: 'nuevo_movimiento_banco',
                    title: 'Nuevo Movimiento Banco',
                    type: 'item',
                    url: '/user/new-movimientos-bancos/0'
                },
                {
                    id: 'lista_movimientos_banco',
                    title: 'Lista Movimientos Banco',
                    type: 'item',
                    url: '/user/list-movimientos-bancos-view'
                },                
            ]
        },
    ]
};

export default efectivo;
